// src/stores/pendencias.js
import { defineStore } from 'pinia'
import api from '@/services/api'

export const usePendenciasStore = defineStore('pendencias', {
  state: () => ({
    total: 0,
    novas: 0
  }),
  actions: {
    async atualizarContagem () {
      try {
        const { data } = await api.get('/AlertasPendencia/contagem', {
          _suppressLoading: true
        })
        this.total = data.total || 0
        this.novas = data.novas || 0
      } catch (e) {
        // Silencia erro para não poluir console
      }
    }
  }
})
